"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _logger = require("./logger"); // Poll for changes to the USP stub function as a
// proxy for when the Quantcast Choice CMP has fully
// loaded. Resolves if successful and rejects if
// it times out.


var awaitCMPLoad =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              (0, _logger.logDebugging)("Polling for CMP to have loaded in updateStoredPrivacyData.");
              var intervalMs = 500;
              var timesChecked = 0;
              var maxTimesToCheck = 20;

              var checkIfCMPLoaded = function checkIfCMPLoaded() {
                return window.tabCMP.uspStubFunction !== window.__uspapi;
              };

              var checker = setInterval(function () {
                var isLoaded = checkIfCMPLoaded();
                (0, _logger.logDebugging)("Polling for CMP loaded. Loaded? ".concat(isLoaded));

                if (isLoaded) {
                  clearInterval(checker);
                  resolve();
                }

                timesChecked += 1;

                if (timesChecked > maxTimesToCheck) {
                  clearInterval(checker);
                  (0, _logger.logDebugging)("Polling for CMP has timed out.");
                  reject(new Error('Timed out while waiting for the CMP.'));
                }
              }, intervalMs);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function awaitCMPLoad() {
    return _ref.apply(this, arguments);
  };
}();

var _default = awaitCMPLoad;
exports.default = _default;